
const GoogleMap = () => {
  return (
    <iframe 
      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3500.7436011272466!2d77.22386867473861!3d28.667394882498098!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390cfd0855ce9e5b%3A0x7ace0466fd055691!2sPS%20Jain%20Motor%20Market!5e0!3m2!1sen!2sin!4v1738937048142!5m2!1sen!2sin" 
      width="100%"
      height="100%"
      style={{ border: "0" }}
      loading="lazy"
      allowFullScreen={true}
      referrerPolicy="no-referrer-when-downgrade"
    />
  );
};

export default GoogleMap;
